import { MorePartsData, MorePartsDataResponse } from "../../../business";
import { MorePartsFilterFactory } from "../../interfaces";

export class MorePartsFilterFactoryImpl implements MorePartsFilterFactory {
    create(morePartsData: MorePartsDataResponse): MorePartsData {
        if (morePartsData?.success && morePartsData.success === true) {
            if (morePartsData.response.moreparts.length === 0) throw new Error("Desculpe-nos! Não foi possível carregar os dados neste momento.");
            return morePartsData.response;
        }
        throw new Error("Desculpe-nos! Não foi possível carregar os dados neste momento.");
    }
}